import { render, staticRenderFns } from "./Pendanaan-Desktop.vue?vue&type=template&id=60168c08&scoped=true"
import script from "./Pendanaan-Desktop.vue?vue&type=script&lang=js"
export * from "./Pendanaan-Desktop.vue?vue&type=script&lang=js"
import style0 from "./Pendanaan-Desktop.vue?vue&type=style&index=0&id=60168c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60168c08",
  null
  
)

export default component.exports